import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Megaphone, Clock } from 'lucide-react';

export default function PromotionsPage() {
  return (
    <div className="space-y-6" data-testid="promotions-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Impulsaciones</h1>
        <p className="text-slate-500 mt-1">Gestión de campañas de impulsación en puntos de venta</p>
      </div>

      <Card className="border-dashed border-2 border-slate-300">
        <CardContent className="flex flex-col items-center justify-center py-16">
          <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mb-6">
            <Megaphone className="w-10 h-10 text-primary" />
          </div>
          <h2 className="text-xl font-semibold text-slate-900 mb-2">Próximamente</h2>
          <p className="text-slate-500 text-center max-w-md mb-4">
            El módulo de Impulsaciones está actualmente en desarrollo. 
            Pronto podrás gestionar campañas de impulsación, coordinar 
            promotores y medir el impacto de tus activaciones en tienda.
          </p>
          <div className="flex items-center gap-2 text-sm text-slate-400">
            <Clock className="w-4 h-4" />
            <span>En desarrollo</span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
